import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import FadeIn from 'react-fade-in';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { layoutDefaults } from '../../utils/layout-defaults';

function PaymentPixInstructionsBody({
  // analyticsFeatureUseEvent,
  analyticsHollowEvent,
  // payload,
  showPayload,
}) {
  const { t } = useTranslation();
  const [showInstructions, setShowInstructions] = useState(false);
  const classes = useStyles({ showInstructions });
  const [steps] = useState(loadSteps(showPayload));

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowInstructions(true);
    }, 1200);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [setShowInstructions]);

  function loadSteps(pShowPayload) {
    const lSteps = [];
    // let step = 1;

    if (pShowPayload) {
      lSteps.push({
        text: <span>{t('pix.instructions.copy-code')}payload</span>,
      });
      // step++;
    }

    // ['Abra o App do banco', `Cole na opção <div id="pix-copy-paste" class="animate__animated animate__rubberBand animate__delay-1s">Pix Copia e Cola</div>`, 'Volte aqui para confirmar o pagamento']
    [
      <span>{t('pix.instructions.step.1')}</span>,
      <span>
        {t('pix.instructions.step.2')}
        <div
          className={classNames(
            classes.copyPaste,
            'animate__animated animate__rubberBand animate__delay-2s'
          )}
          style={{ '--animate-delay': '0.57s' }}
          onClick={onClick}
          aria-hidden
        >
          {t('pix.instructions.step.2.1')}
        </div>
      </span>,
      <span>{t('pix.instructions.step.3')}</span>,
    ].forEach((text) => {
      lSteps.push({ text });
      // step++;
    });

    return lSteps;
  }

  function onClick() {
    analyticsHollowEvent('pix copy & paste click');
  }

  return (
    <div className={classes.container}>
      {showInstructions && (
        <FadeIn>
          <div className={classes.instructions}>
            <div className={classes.title}>{t('pix.instructions.follow')}</div>
            {steps?.map((step, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <div key={index} className={classes.instruction}>
                <FadeIn delay={index * 800 + (index === 2 ? 400 : 0)}>
                  <div>
                    <span className={classes.instructionStep}>
                      {index + 1}{' '}
                    </span>
                    <span className={classes.instructionText}>{step.text}</span>
                  </div>
                </FadeIn>

                {showPayload && (
                  <textarea id="pix-payload" readOnly="true">
                    payload
                  </textarea>
                )}
              </div>
            ))}
          </div>
        </FadeIn>
      )}

      {/* <PixQRCode
                analyticsFeatureUseEvent={analyticsFeatureUseEvent}
                analyticsHollowEvent={analyticsHollowEvent}
                payload={payload}
            /> */}
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    // fontSize: layoutDefaults.fontSize,
    marginTop: ({ showInstructions }) =>
      showInstructions ? -layoutDefaults.smallVerticalMargin : -100,
    // border: '1px solid red',
  },
  instructions: {
    // marginTop: 12,
    textAlign: 'left',
    fontSize: layoutDefaults.bigFontSize,
    backgroundColor: layoutDefaults.backdropColor,

    // padding: "8px 8px 14px 20px",
    paddingLeft: layoutDefaults.bigHorizontalMargin,
    paddingRight: layoutDefaults.bigHorizontalMargin,
    paddingTop: layoutDefaults.verticalMargin,
    paddingBottom: layoutDefaults.verticalMargin,
    marginBottom: layoutDefaults.smallVerticalMargin,
    border: '1px dashed #bbb',
    borderRadius: layoutDefaults.radius,
  },
  title: {
    textTransform: 'uppercase',
    fontSize: layoutDefaults.smallestFontSize,
    opacity: layoutDefaults.opacity,
    marginBottom: layoutDefaults.smallVerticalMargin,
  },
  instruction: {
    // textAlign: "left",
    /* display: flex;
        flex-direction: column; */
    // fontSize: layoutDefaults.bigFontSize,
    // fontSize: layoutDefaults.biggerFontSize,
    marginTop: layoutDefaults.smallVerticalMargin,
    marginBottom: layoutDefaults.smallVerticalMargin,
  },
  instructionStep: {
    fontSize: layoutDefaults.biggestFontSize,
    fontWeight: 'bold',
  },
  instructionText: {},
  copyPaste: {
    color: '#555',
    /* font-size: 1.1em; */
    /* border: 1px dashed #555; */
    whiteSpace: 'nowrap',
    // fontSize: '1em',

    backgroundColor: '#ddd',
    padding: '2px 10px 3px 9px',
    marginBottom: 4,
    borderRadius: 6,

    display: 'inline-block',
  },
});

export { PaymentPixInstructionsBody };
